import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Classes from "@/pages/Classes";
import BabySwimming from "@/pages/BabySwimming";
import ToddlerSwimming from "@/pages/ToddlerSwimming";
import ChildrensSwimming from "@/pages/ChildrensSwimming";
import TimetablePage from "@/pages/TimetablePage";
import About from "@/pages/About";
import TeamPage from "@/pages/TeamPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ContactPage from "@/pages/ContactPage";
import HowItWorks from "@/pages/HowItWorks";
import BookNow from "@/pages/BookNow";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import PricingPage from "@/pages/PricingPage";
import TermDatesPage from "@/pages/TermDatesPage";
import Admin from "@/pages/Admin";
import CookieNotice from "@/components/site/CookieNotice";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";
import { Toaster } from "@/components/ui/toaster";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/classes/baby-swimming" element={<BabySwimming />} />
          <Route path="/classes/toddler-swimming" element={<ToddlerSwimming />} />
          <Route path="/classes/childrens-swimming" element={<ChildrensSwimming />} />
          <Route path="/timetable" element={<TimetablePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/book" element={<BookNow />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/term-dates" element={<TermDatesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <CookieNotice />
        <StickyMobileCTA />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
